import React, { useContext } from 'react';

import styled from '@emotion/styled';

import useResolveConflict from '../../../../hooks/dashboard/driver-list/useResolveConflict';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

interface ResolveConflictModalProps {
  data: any;
}

const ResolveConflictModal: React.FC<ResolveConflictModalProps> = ({
  data,
}) => {
  const modalContext = useContext(ModalContext);
  const { resolveConflict, loading } = useResolveConflict();

  const onConfirm = () => {
    resolveConflict(data, () => {
      modalContext?.setShowModal(false);
    });
  };

  return (
    <ModalContainer label='Resolve Conflict'>
      <Message>
        Are sure you have reviewed the Conflict information received?
      </Message>

      {/* <CustomSelectField
        name='selector'
        id='selector'
        placeholder={activeField || 'Select Option'}
        onChange={handleFieldChange('selector')}
        optionData={options}
      /> */}
      <ButtonArea>
        <FormSubmitButton
          className='clear fill'
          onClick={() => modalContext?.setShowModal(false)}
          btnType='button'
        >
          Cancel
        </FormSubmitButton>
        <FormSubmitButton
          loading={loading}
          onClick={onConfirm}
          className='fill'
        >
          Confirm
        </FormSubmitButton>
      </ButtonArea>
    </ModalContainer>
  );
};

const Message = styled.div`
  margin: 32px 0 40px 0;
  font-size: 14px;
  color: #6b7280;
`;

const ButtonArea = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
`;

export default ResolveConflictModal;
